// extracted by mini-css-extract-plugin
export default {"list":"FaqsComp_list__TOecU"};